// Sentry must initialize before any other module loads
import './lib/sentry' // force redeploy 2026-07-28 (paver-app build for Return to Draft + submitted-estimate lock UI)

import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { GlobalErrorBoundary } from './components/global-error-boundary'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <GlobalErrorBoundary>
      <App />
    </GlobalErrorBoundary>
  </React.StrictMode>
)
